import * as z from 'zod';

// Types
import { MediaZod } from '@/types/MediaType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';
import { TextZod } from '@/components/molecules/Text/TextType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';
import { TitleZod } from '@/types/TitleType';
import { BubbleStyleZod } from '@/types/BubbleStyleType';
import { getBusinessSectorEnumValues } from '@/enum/BusinessSectorEnum';
import { getSupportTypeEnumValues } from '@/enum/SupportTypeEnum';

const KeyFigureZod = z.object({
  id: z.number(),
  title: TitleZod,
  paragraph: ParagraphZod,
  bubbleStyle: BubbleStyleZod.nullable(),
});

export type KeyFigureType = z.infer<typeof KeyFigureZod>;

const LogoClientZod = z.object({
  id: z.number(),
  name: z.string(),
  logo: MediaZod,
  businessSector: z.enum(getBusinessSectorEnumValues()),
  supportTypes: z.array(z.enum(getSupportTypeEnumValues())),
});

export type LogoClientType = z.infer<typeof LogoClientZod>;

const LogoClientsZod = z.object({
  __component: z.literal('block.logo-clients'),
  id: z.number(),
  text: TextZod,
  waveWrapper: WaveWrapperZod.nullable(),
  clients: z.array(LogoClientZod).nullable(),
  keyFigures: z.array(KeyFigureZod).nullable(),
  showFilterButtons: z
    .boolean()
    .nullable()
    .optional()
    .transform((val) => val !== false),
});

export { LogoClientsZod };
export type LogoClientsType = z.infer<typeof LogoClientsZod>;
